import { Fragment } from 'react';
import AvailableMeals from './AvailableMeals/AvailableMeals';
import MealSummary from './MealSummary/MealSummary';

const Meals = () => {
  return (
    <Fragment>
      <MealSummary />
      <AvailableMeals />
    </Fragment>
  );
};

export default Meals;
